var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTokenBooster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_352_698",
    x1: 11.9453,
    y1: 2.98092,
    x2: 12.2763,
    y2: 24.7122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF962E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_352_698",
    x1: 15.5412,
    y1: 6.25137,
    x2: 8.50863,
    y2: 18.8611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF962E"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.999
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.589 10.932H20.5925V10.5268C20.5925 5.82532 16.782 2.01877 12.0845 2.01877C7.3869 2.01877 3.57289 5.82885 3.57289 10.5268V13.5107C3.57289 18.2122 7.38337 22.0188 12.0809 22.0188C16.7785 22.0188 20.589 18.2087 20.589 13.5107V10.932Z",
    fill: "url(#paint0_linear_352_698)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9518 11.015C16.9518 8.29711 14.875 5.94362 12.1572 5.94362C9.43933 5.94362 7.23873 8.14776 7.23873 10.8621C7.23873 11.6018 7.26428 12.7856 7.27882 13.5253C7.32991 16.1739 9.49043 18.7243 12.2083 18.7243C14.9261 18.7243 17.0029 16.5202 17.0646 13.846C17.0827 13.1063 16.9518 11.7546 16.9518 11.015Z",
    fill: "url(#paint1_linear_352_698)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M7.00134 14.2858L7.32087 13.9179C7.31891 13.7898 7.30279 13.4506 7.28825 13.0933L4.48905 16.1716L4.44818 16.2286C4.52325 16.4373 4.60461 16.6401 4.69382 16.8374C5.16665 16.3127 5.99281 15.3993 7.00094 14.2858H7.00134Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M7.7312 15.5714L5.41819 18.1151C6.02818 18.9767 6.84962 19.7635 7.71509 20.3417C8.13445 19.8759 8.88437 19.0466 9.81507 18.0184C8.84035 17.4391 8.14546 16.5367 7.7312 15.571V15.5714Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M16.5631 3.78036C16.4031 3.66284 16.2498 3.55318 16.0706 3.44824L13.6185 6.1594C13.7883 6.24705 14.0229 6.29146 14.2084 6.37714C14.9894 5.51561 15.7904 4.63246 16.5631 3.78036Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M17.6652 4.65406L15.3191 7.23434C15.3993 7.29723 15.4705 7.35382 15.4952 7.37898V7.38252C16.42 8.31008 16.716 9.04348 16.8524 10.2756C17.9855 9.02658 18.9469 7.96696 19.5313 7.32277C19.0907 6.30992 18.4532 5.40398 17.6652 4.65367V4.65406Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.154 6.08197C14.7225 6.08197 16.8103 8.29358 16.8103 11.015C16.8103 11.3172 16.8323 12.3521 16.8579 13.5434C16.8944 15.2774 16.9381 13.405 16.927 13.8421C16.8653 16.5017 14.7921 18.5856 12.2091 18.5856C10.9631 18.5856 9.76791 18.0318 8.84624 17.0264C7.96073 16.0607 7.43996 14.7857 7.41441 13.5253C7.39987 12.793 7.37433 11.6525 7.37433 10.8656C7.37433 8.22794 9.5203 6.08197 12.1544 6.08197H12.154ZM12.154 5.94362C9.43619 5.94362 7.23558 8.14776 7.23558 10.8621C7.23558 11.6018 7.26113 12.7856 7.27567 13.5253C7.33031 16.1739 9.49082 18.7243 12.2087 18.7243C14.9265 18.7243 17.0033 16.5202 17.0654 13.846C17.0835 13.1063 16.9487 11.7546 16.9487 11.015C16.9522 8.29711 14.8719 5.94362 12.154 5.94362Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.62154 13.8896V11.1753C7.62154 8.61036 9.70188 6.53003 12.2668 6.53003C14.0048 6.53003 15.564 7.53934 16.3619 8.9527C15.7935 7.30588 13.9573 6.06349 12.0554 6.06349C9.49043 6.06349 7.41363 8.19492 7.41363 10.7599V13.4742C7.41363 14.3011 7.63216 15.0809 8.01104 15.7514C7.7595 15.1796 7.62115 14.5491 7.62115 13.8896H7.62154Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1824 8.83675L9.45938 12.5808C9.39689 12.7168 9.49632 12.8717 9.64568 12.8717H11.0417C11.1762 12.8717 11.274 12.9986 11.2402 13.1283L10.5265 15.8815C10.4726 16.0894 10.7336 16.2297 10.8774 16.0706L14.9497 11.5526C15.0704 11.4186 14.9721 11.2052 14.7917 11.2103L12.9924 11.2594C12.8434 11.2634 12.74 11.1124 12.7974 10.9753L13.6389 8.96331C13.6959 8.82653 13.5941 8.67639 13.4459 8.67914L11.3648 8.71806C11.2862 8.71963 11.2151 8.76601 11.1821 8.83754L11.1824 8.83675Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTokenBooster);
export default __webpack_public_path__ + "static/media/icon-token-booster.795126575a46502a34e14c3e269389ce.svg";
export { ForwardRef as ReactComponent };